import { Controller } from "@hotwired/stimulus";
import Axios from "axios";

// The sub-notes list's group-by-date toggle (LI-265; see notes/subnotes/component.html.haml). Both
// lists are rendered, so toggling only swaps which one is hidden. A member's choice is saved per
// note in the background (fire and forget, through `url`); a guest has no url, and theirs is kept
// in this browser's localStorage instead, under notes-grouping:<note id>.
export default class extends Controller {
  static targets = ["toggle", "grouped", "ungrouped"];
  static values = { grouped: Boolean, noteId: String, url: String };

  connect() {
    if (this.hasUrlValue) return;

    const stored = this.readStored();
    if (stored !== null) this.groupedValue = stored;
  }

  toggle() {
    this.groupedValue = !this.groupedValue;
    this.save();
  }

  groupedValueChanged(grouped) {
    this.groupedTargets.forEach((list) => { list.hidden = !grouped; });
    this.ungroupedTargets.forEach((list) => { list.hidden = grouped; });
    this.toggleTargets.forEach((button) => button.setAttribute("aria-pressed", String(grouped)));
  }

  save() {
    if (this.hasUrlValue) {
      const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
      Axios.patch(this.urlValue, { grouped: this.groupedValue }, { headers: { "X-CSRF-Token": csrf } }).catch(() => {});
    } else {
      this.writeStored();
    }
  }

  get storageKey() {
    return `notes-grouping:${this.noteIdValue}`;
  }

  // Storage can be blocked (private windows, strict settings): fall back to the default quietly.
  readStored() {
    try {
      const value = window.localStorage.getItem(this.storageKey);
      return value === null ? null : value === "grouped";
    } catch (_error) {
      return null;
    }
  }

  writeStored() {
    try {
      window.localStorage.setItem(this.storageKey, this.groupedValue ? "grouped" : "ungrouped");
    } catch (_error) {
      // Nothing to do: the choice just won't survive a reload.
    }
  }
}
